import React from "react";
import { Link } from "@reach/router";

import copy from "../assets/copy/howToPlay";
import textureBG from "../assets/img/jep-bg.png";
import cards from "../assets/img/hiw-card.png";
import question from "../assets/img/hiw-answer.png";

/** @jsx jsx */
import { jsx, css } from "@emotion/core";

const Column = ({ children }) => (
	<div
		css={css`
			display: flex;
			flex: 1 1 0;
		`}
	>
		{children}
	</div>
);

const ListItem = ({ number, body, heading }) => (
	<div
		css={css`
			display: flex;
		`}
	>
		<div
			css={css`
				color: #bbd331;
				font-size: 3.5em;
				font-family: LunchBox;
			`}
		>
			<span
				css={css`
					float: left;
					width: 2rem;
				`}
			>
				{number}.
			</span>
		</div>
		<div
			css={css`
				margin-left: 1em;

				h2 {
					font-size: 2rem;
					font-weight: 300;
					margin-bottom: 0.5rem;
					margin-top: 0;
				}

				p {
					font-size: 1.25rem;
					margin-top: 0.5rem;
				}
			`}
		>
			<h2>{heading}</h2>
			<p>{body}</p>
		</div>
	</div>
);

const HowToPlay = () => {
	return (
		<div
			css={css`
				display: flex;
				width: 100%;
				height: 100%;

				position: absolute;

				background: #4e97c8;
				color: white;
			`}
		>
			<Column>
				<div
					css={css`
						width: 100%;
						height: 100%;
						background-image: url(${textureBG});
						background-size: cover;
						background-repeat: no-repeat;
						background-position: center;

						font-size: 1rem;
						padding: 3rem;
						font-weight: bold;
						line-height: 1.5rem;

						h1 {
							font-family: LunchBox;
							font-size: 3rem;
						}
					`}
				>
					<h1>{copy.left.heading}</h1>
					<p>{copy.left.body}</p>
				</div>
			</Column>
			<Column>
				<div
					css={css`
						padding: 2em;
					`}
				>
					<div>
						<ListItem number="1" heading={copy.one.heading} body={copy.one.body} />
						<ListItem number="2" heading={copy.two.heading} body={copy.two.body} />
						<ListItem number="3" heading={copy.three.heading} body={copy.three.body} />
					</div>
				</div>
			</Column>
			<Column>
				<div
					css={css`
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: center;

						width: 100%;
						height: 100%;

						* {
							margin: 1em;
						}
					`}
				>
					<img
						alt="Jeopardy! Card"
						css={css`
							width: 80%;
						`}
						src={cards}
					/>

					<img
						alt="Question"
						css={css`
							width: 80%;
						`}
						src={question}
					/>
					<Link to="/play/Brain_Trivia/play">
						<button
							type="button"
							css={css`
								display: flex;
								justify-content: center;
								align-items: center;

								width: 100%;

								color: white;
								font-weight: bold;
								font-size: 1.5rem;

								background-color: #bbd331;
								border: none;
								border-radius: 6px;

								padding: 10px;
								margin-bottom: 20px;
							`}
						>
							LET&apos;S GET STARTED
						</button>
					</Link>
				</div>
			</Column>
		</div>
	);
};

export default HowToPlay;
